import { MediaElement } from 'editor/src/store/design/types';

function useIsInteractable(elementData: MediaElement, ignorePersonalizationLock: boolean) {
  const isInteractable = !elementData.hidden && (!elementData.personalizationLocked || ignorePersonalizationLock);

  return isInteractable && !elementData.static;
}

export default useIsInteractable;
